/* eslint-disable @next/next/no-img-element */
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { drawerWidth } from "@/themes/themeConstant";
import IconButton from "@mui/material/IconButton";
import {
  Box,
  Button,
  List,
  ListItem,
  Menu,
  MenuItem,
  styled,
} from "@mui/material";
import Link from "next/link";
import Image from "next/image";
import assest from "@/json/assest";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import useNotiStack from "@/hooks/useNotistack";
import { logout } from "@/reduxtoolkit/slices/userSlice";
// import { GetServerSideProps } from "next";
// import { GetprofileData } from "@/api/functions/user.api";
// import { useQuery } from "react-query";
// import axiosInstance from "@/api/axiosInstance";
import { baseUrl } from "@/api/endpoints";
// import { useSelector } from "react-redux";
import { useAppSelector } from "@/hooks/useAppSelector";
import DialogWrapper from "@/components/DialogWrapper/DialogWrapper";
import Profileupdate from "@/components/ProfileUpdate/Profileupdate";
import ChangePassword from "@/components/ChangePassword/ChangePassword";

const DialogModal = styled(Box)`
  .serviceModal {
    .serviceModalTxt {
      h4 {
        font-weight: 600;
        font-size: 24px;
        line-height: 1.5;
        color: #2b2d42;
        margin: 0 0 8px;
      }
      p {
        font-weight: 400;
        font-size: 12px;
        line-height: 1.5;
        color: #8d99ae;
        margin: 0 0 24px;
      }
      .inputWrapper {
        text-align: left;
        margin: 0px 0 18px;
        label {
          font-weight: 600;
          font-size: 14px;
          line-height: 1.6;
          color: #121d32;
          margin: 0 0 6px;
          sup {
            color: #eb2f2f;
          }
        }
        input {
          background: #ffffff;
          border: 1px solid #8d99ae;
          border-radius: 6px;
          padding: 8px 12px;
          text-transform: capitalize;
          &::placeholder {
            color: #8d99ae;
          }
        }
        select {
          background-color: #ffffff;
          border: 1px solid #8d99ae;
          border-radius: 6px;
          padding: 8px 12px;
          color: #8d99ae;
          text-transform: capitalize;
          &::placeholder {
            color: #8d99ae;
          }
        }
      }
    }

    .buttonGroup {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      button {
        min-width: 176px;
        margin: 0 21px 0 0;
        @media (max-width: 575px) {
          max-width: 100%;
          margin: 0 0 10px;
          width: 100%;
        }
        &:last-child {
          margin: 0;
        }
        p {
          font-weight: 600;
          font-size: 16px;
          line-height: 1.6;
          color: #ffffff;
          margin: 0;
        }
      }
    }
  }
`;
// export const getServerSideProps: GetServerSideProps = async (context: any) => {
//   let res = await GetprofileData()
//   return {
//     props: {
//    profileData : res
//     }
//   };
// };

//styled

const HeaderWrapper = styled(Box)`
  .headerWrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* flex-wrap: wrap; */
    @media (max-width: 899px) {
      padding: 0 0 0 50px;
    }
    @media (max-width: 375px) {
      padding: 0 0 0 35px;
    }
    .MuiTypography-h4 {
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #121d32;
      @media (max-width: 575px) {
        font-size: 13px;
      }
    }
    ul {
      display: flex;
      align-items: center;
      /* flex-wrap: wrap; */
      padding: 0;
      li {
        padding: 0;
        margin: 0 19px 0 0;
        width: auto;
        @media (max-width: 575px) {
          margin: 0 5px 0 0;
        }
        &:last-child {
          margin: 0;
        }
        a {
          position: relative;
          line-height: 0;
          cursor: pointer;
          img {
            @media (max-width: 375px) {
              max-width: 16px;
              width: 100%;
            }
          }
          .profileDetails {
            display: flex;
            align-items: center;
            max-width: 146px;
            width: 100%;
            img {
              max-width: 38px;
              height: 38px;
              border-radius: 50%;
              margin: 0 8px 0 0;
              @media (max-width: 575px) {
                margin: 0 15px 0 0;
              }
              @media (max-width: 375px) {
                margin: 0 15px 0 0;
                max-width: 25px;
                height: 25px;
              }
            }
            h4 {
              font-weight: 400;
              /* font-size: 16px; */
              font-size: 12px;
              line-height: 1.4;
              display: flex;
              align-items: center;
              color: #192a3e;
              flex-wrap: wrap;
              @media (max-width: 575px) {
                display: none;
              }
              span {
                width: 100%;
                font-weight: 400;
                font-size: 12px;
                color: #d90429;
              }
            }
            &:before {
              position: absolute;
              background: url(/assets/images/downArrow.svg);
              content: "";
              width: 11px;
              height: 7px;
              right: 0;
              top: 50%;
              transform: translate(0%, -50%);
            }
          }
        }
        &.notificationIcon {
          span {
            background: #ec3c46;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }
`;
const ToolMenu = styled(Box)`
  .menuTool {
    padding: 0;
    display: block;
    min-height: auto;
  }
`;

interface DashboardHeaderInterFace {
  onClick: () => void;
  name: string;
}

const DashboardHeader = (props: DashboardHeaderInterFace) => {
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const { toastSuccess } = useNotiStack();
  const dispatch = useAppDispatch();
  const { onClick, name } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { userData } = useAppSelector((state) => state.userSlice);

  const handleClose1 = () => {
    setOpen1(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  // React.useEffect(() => {
  //   dispatch(setuserprifileData());
  // }, [])

  const logoutFunc = () => {
    dispatch(logout());
    toastSuccess("Logout Successful");
  };

  const handleClickOpen = () => {
    setOpen1(true);
    setAnchorEl(null);
  };

  const handleClickOpenPassword = () => {
    setOpen2(true);
    setAnchorEl(null);
  };


  const onErrorImg = (ev: { target: { src: string } }) => {
    ev.target.src = assest.noimg;
  };


  return (
    <AppBar
      position="fixed"
      className="headerMain"
      sx={{
        width: { sm: `100%`, md: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        backgroundColor: { sm: `#fff` },
        padding: { sm: `18px 16px` },
      }}
    >
      <ToolMenu>
        <Box>
          <Toolbar className="menuTool">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={onClick}
              sx={{
                mr: 2,
                display: { md: "none", sm: "block", lg: "none", xs: "block" },
              }}
            >
              <MenuIcon />
            </IconButton>

            <HeaderWrapper>
              <Box className="headerWrapper">
                {/* <Typography variant="h4" noWrap component="div">
                  {name}
                </Typography> */}

                <List>
                  <ListItem>
                    {/* <Link href="">
                      <Image
                        src={assest.mailGrayIcon}
                        width={20}
                        height={15}
                        alt=""
                      />
                    </Link> */}
                  </ListItem>
                  <ListItem className="notificationIcon">
                    {/* <Link href="">
                      <Image
                        src={assest.notificationGrayIcon}
                        width={17}
                        height={21}
                        alt=""
                      />
                      <span></span>
                    </Link> */}
                  </ListItem>
                  <ListItem>
                    {/* <Link href="">
                      <Image
                        src={assest.settingGrayIcon}
                        width={19}
                        height={20}
                        alt=""
                      />
                    </Link> */}
                  </ListItem>
                  <ListItem>
                    <Link href="#">
                      <Box className="profileDetails" onClick={handleClick}>
                        
                        {userData?.profile_image !== null ? (
                          <img
                            src={`${baseUrl}/uploads/user/profile_images/${userData?.profile_image}`}
                            alt="img"
                            width={70}
                            height={40}
                            onError={onErrorImg}
                          />
                        ) : (
                          <Image
                            src={assest.noImage}
                            alt="img"
                            width={40}
                            height={40}
                          />
                        )} 

                        <h4
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                        >
                          <span>Welcome </span> {userData?.full_name}
                        </h4>
                      </Box>
                    </Link>
                  </ListItem>
                </List>
                <div>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={handleClickOpen}>Profile</MenuItem>
                    <MenuItem onClick={handleClickOpenPassword}>
                      Change Password
                    </MenuItem>
                    <MenuItem onClick={logoutFunc}>Logout</MenuItem>
                  </Menu>
                </div>
              </Box>
            </HeaderWrapper>
          </Toolbar>
        </Box>
      </ToolMenu>
      <DialogWrapper
        type="service"
        onClose={handleClose1}
        aria-labelledby="customized-dialog-title"
        open={open1}
        className={"adsModal"}
      >
        <DialogModal>
          <Profileupdate
            handleClose={handleClose1}
            // fetchListRole={fetchListRole}
            // isSuccess ={isSuccess}
            userdata={userData}
          />
        </DialogModal>
      </DialogWrapper>

      <DialogWrapper
        type="service"
        onClose={handleClose2}
        aria-labelledby="customized-dialog-title"
        open={open2}
        className="adsModal"
      >
        <DialogModal>
          <ChangePassword handleClose={handleClose2} />
        </DialogModal>
      </DialogWrapper>
    </AppBar>
  );
};

export default DashboardHeader;
